/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getCodedValueList = (payload, callback) =>
  req.list(
    c.GET_CODED_VALUE_LIST,
    'api/v1/rpt/administrator/settings/tax_exempt_codes',
    payload,
    callback
  );

export const getSingleCodedValue = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_CODED_VALUE,
    `api/v1/rpt/administrator/settings/tax_exempt_codes/${id}`,
    payload,
    callback
  );

export const createCodedValue = (payload, callback) =>
  req.create(
    c.CREATE_CODED_VALUE,
    'api/v1/rpt/administrator/settings/tax_exempt_codes',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateCodedValue = (id, payload, callback) =>
  req.update(
    c.UPDATE_CODED_VALUE,
    `api/v1/rpt/administrator/settings/tax_exempt_codes/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeCodedValue = (id, payload, callback) =>
  req.remove(
    c.REMOVE_CODED_VALUE,
    `api/v1/rpt/administrator/settings/tax_exempt_codes/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );
